/*
  Masthead ground.

  The bar is transparent so a page's opening band shows through it. The moment
  the page moves, the bar has to take a solid ground or the nav is white type
  over whatever happens to be underneath — which on a cream page is nothing at
  all.

  Dawn's own .scrolled-past-header is not sufficient here: it does not fire on
  an anchor jump (arriving at /collections/...#shop lands mid-page with the
  class absent), and it depends on an IntersectionObserver rect that a
  zero-height header never produces. This is a plain scroll position test.
*/
(function () {
  'use strict';
  var root = document.documentElement;
  var TOP = 8;
  var ticking = false;

  function sync() {
    ticking = false;
    root.classList.toggle('fl-scrolled', window.scrollY > TOP);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(sync);
  }

  sync();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('hashchange', sync);

  /* A hash jump (arriving at /collections/...#shop) moves the page WITHOUT
     firing a scroll event, and it happens after this script runs — so the first
     sync sees scrollY 0 and the bar stays transparent halfway down a cream
     page. Re-check once the document has finished loading and once more on the
     next frame, by which point the browser has applied the fragment. */
  window.addEventListener('load', function () {
    sync();
    window.requestAnimationFrame(sync);
  });
})();
